/**
 * 最寄駅関連のユーティリティ関数
 * FL-268: 陸送員情報管理 - 最寄駅表示機能
 */

/**
 * 最寄駅文字列から駅名のみを抽出
 * 「東京都目黒区東山３丁目２ 池尻大橋駅」 → 「池尻大橋駅」
 *
 * @param stationString - 住所+駅名の形式の文字列、またはnull/undefined
 * @returns 抽出した駅名、またはデータがない場合は '-'
 *
 * @example
 * extractStationName('東京都目黒区東山３丁目２ 池尻大橋駅') // '池尻大橋駅'
 * extractStationName('渋谷駅') // '渋谷駅'
 * extractStationName(null) // '-'
 * extractStationName('') // '-'
 */
export function extractStationName(stationString: string | null | undefined): string {
  if (!stationString) return '-';

  // 駅名パターン: 「漢字・ひらがな・カタカナ・数字・ー」＋「駅」
  // ハイフンは括弧内の先頭に配置して曖昧性を排除
  const match = stationString.match(/([-ァ-ヴー一-龥ぁ-ゟ０-９]+駅)/);
  return match ? match[1] : stationString;
}
